"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNED_ATTRIBUTES = void 0;
exports.SIGNED_ATTRIBUTES = ["data", "signer", "signedDate", "uuid", "type"];
//# sourceMappingURL=token.js.map